import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AchievementsPanel } from "../components/AchievementsPanel";
import { EnterpriseCustomerSelectionCard } from "../components/EnterpriseCustomerState";
import { ensureEnterpriseCustomerContext } from "../lib/enterpriseCustomerContext";
import {
  achievementsQueryOptions,
  useGetAchievements,
} from "../queries/useGetAchievements";
import { useGetCustomerContext } from "../queries/useGetCustomerContext";

function AchievementsRouteComponent() {
  const { t } = useTranslation();
  const { externalCustomerId } = Route.useSearch();
  if (!externalCustomerId) {
    return (
      <EnterpriseCustomerSelectionCard
        description={t(
          "enterprise.routes.achievements.selectCustomerDescription",
        )}
      />
    );
  }

  return <AchievementsRouteContent externalCustomerId={externalCustomerId} />;
}

function AchievementsRouteContent({
  externalCustomerId,
}: {
  externalCustomerId: string;
}) {
  const { data: customer } = useGetCustomerContext(externalCustomerId);
  const { data } = useGetAchievements(customer.customerId);
  return <AchievementsPanel data={data} />;
}

export const Route = createFileRoute("/_app/achievements")({
  loaderDeps: ({ search }) => ({
    externalCustomerId: search.externalCustomerId,
  }),
  loader: async ({ context, deps }) => {
    if (!deps.externalCustomerId) {
      return;
    }
    const customer = await ensureEnterpriseCustomerContext(
      context.queryClient,
      deps.externalCustomerId,
    );
    return context.queryClient.ensureQueryData(
      achievementsQueryOptions(customer.customerId),
    );
  },
  component: AchievementsRouteComponent,
});
